module.exports = "/_next/static/images/501fe4e7df4d000220b9cd245b2cce07-roxinho-details-metalico-lg@2x.jpg.webp";